import $ from 'jquery';

function loadScripts() {
  console.log('loadScripts function called');
  // Hubspot loading forms script and load forms scripts
  var scriptFormsLoad = document.createElement('script');
  scriptFormsLoad.id = 'hubspot_load_forms_cookie';
  scriptFormsLoad.src = 'https://js-na3.hsforms.net/forms/embed/v2.js';
  document.head.append(scriptFormsLoad);
  console.log('hubspot load forms script added');

  var dynamicsScript = document.createElement('script');
  dynamicsScript.id = 'dynamics_form_script';
  dynamicsScript.src = 'https://formui-usa1.mkt.dynamics.com/can/FormLoader/FormLoader.bundle.js';
  document.head.append(dynamicsScript);

  // Hotjar script
  if ($('#hotjar_reloaded').length == 0) {
    var hotjarScript = document.createElement('script');
    hotjarScript.id = 'hotjar_reloaded';
    hotjarScript.async = true;
    hotjarScript.innerHTML =
      "(function(h, o, t, j, a, r) {h.hj = h.hj || function() {(h.hj.q = h.hj.q || []).push(arguments)};h._hjSettings = {hjid: 3863711,hjsv: 6};a = o.getElementsByTagName('head')[0];r = o.createElement('script');r.async = 1;r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;a.appendChild(r);})(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');";
    document.head.append(hotjarScript);
    console.log('hotjar script added');
  }

  // Google Tag Manager scripts
  if ($('#gtm_reloaded').length == 0) {
    var gtagScript = document.createElement('script');
    gtagScript.id = 'gtm_reloaded';
    gtagScript.async = true;
    gtagScript.innerHTML = "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-WVQLG62');";
    //gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=GTM-WVQLG62';
    document.head.prepend(gtagScript);
    //console.log('Google Tag script added - G-TQK8B653YC"');
  }
  if ($('#gtag_reloaded').length == 0) {
    var gtagScript = document.createElement('script');
    gtagScript.id = 'gtag_reloaded';
    gtagScript.async = true;
    gtagScript.src =
      'https://www.googletagmanager.com/gtag/js?id=G-TQK8B653YC';
    document.head.prepend(gtagScript);
    //console.log('Google Tag script added - G-TQK8B653YC"');
  }
  // Google Tag script
  if ($('#gtag_init').length == 0) {
    var gtmScript = document.createElement('script');
    gtmScript.id = 'gtag_init';
    gtmScript.innerHTML = "window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag('js', new Date());gtag('config', 'G-TQK8B653YC');";
    document.head.append(gtmScript);
  }
}

var ensSaveCheck = setInterval(function () {
  if ($('#ensSave').length) {
    console.log('ensSave exists!');
    clearInterval(ensSaveCheck);

    $('#ensSave').on('click', function () {
      console.log('custom settings saved');

      loadScripts();
      if($('#hubspot_load_forms_cookie').length && $('#hubspot_load_forms_cookie').attr('src') == 'https://js-na3.hsforms.net/forms/embed/v2.js') {
        console.log('hubspot load forms cookie script is ready');

        var hbsptDefined = setInterval(function(){
          if(typeof hbspt !== 'undefined') {
            clearInterval(hbsptDefined);
            $('script').each(function (index) {
              if ($(this).html().indexOf('hbspt.forms.create') != -1) {
                if($(this).siblings('.hbspt-form').length == 0) {
                  var scriptForm = document.createElement('script');
                  scriptForm.innerHTML = $(this).html();
                  scriptForm.id = 'reloaded_script_' + index;
                  try {
                    $(this).parent().append(scriptForm);
                    if ($('head').find('.hbspt-form').length) {
                      $('head').find('.hbspt-form').appendTo($(this).parent());
                      console.log('form inserted');
                    }
                  } catch (error) {
                    console.log("ERROR MESSAGE: ", error);
                  }
                }
              }
            });
          } else {
            console.log('hubspot script loaded but hbspt function not available yet');
          }
        }, 500);
      }
      
      /*
      var checkScriptFormsLoad = setInterval(function () {
        if($('script#hubspot_load_forms_cookie_manager').length) {
          if($('script#hubspot_load_forms_cookie_manager').length > 1) {
            console.log('hubspot load forms cookie manager script MORE THAN 2');

            $('script#hubspot_load_forms_cookie_manager').each(function(index){
              if($(this).attr('src') == 'https://js-na3.hsforms.net/forms/embed/v2.js') {
                $('script').each(function (index) {
                  if ($(this).html().indexOf('hbspt.forms.create') != -1) {
                    var scriptForm = document.createElement('script');
                    scriptForm.innerHTML = $(this).html();
                    scriptForm.id = 'reloaded_script_' + index;
                    $(this).parent().append(scriptForm);
                    if ($('head').find('.hbspt-form').length) {
                      $('head').find('.hbspt-form').appendTo($(this).parent());
                      console.log('form inserted');
                    }
                  }
                });
              }
            });
          } else if($('script#hubspot_load_forms_cookie_manager').attr('src') == 'https://js-na3.hsforms.net/forms/embed/v2.js') {
            $('script').each(function (index) {
              if ($(this).html().indexOf('hbspt.forms.create') != -1) {
                var scriptForm = document.createElement('script');
                scriptForm.innerHTML = $(this).html();
                scriptForm.id = 'reloaded_script_' + index;
                $(this).parent().append(scriptForm);
                if ($('head').find('.hbspt-form').length) {
                  $('head').find('.hbspt-form').appendTo($(this).parent());
                  console.log('form inserted');
                }
              }
            });
          }
          //console.log($('script#hubspot_load_forms_cookie_manager').isArray);
          //console.log($('script#hubspot_load_forms_cookie_manager').attr('src'));
          clearInterval(checkScriptFormsLoad);
        }
      });
      */

      /*
      var checkScriptFormsLoad = setInterval(function () {
        if ($('script#hubspot_load_forms_cookie_manager').length && $('script#hubspot_load_forms_cookie_manager').attr('src') == 'https://js-na3.hsforms.net/forms/embed/v2.js') {
          console.log('hubspot script loaded');
          clearInterval(checkScriptFormsLoad);

          $('script').each(function (index) {
            if ($(this).html().indexOf('hbspt.forms.create') != -1) {
              var scriptForm = document.createElement('script');
              scriptForm.innerHTML = $(this).html();
              scriptForm.id = 'reloaded_script_' + index;
              $(this).parent().append(scriptForm);
              if ($('head').find('.hbspt-form').length) {
                $('head').find('.hbspt-form').appendTo($(this).parent());
                console.log('form inserted');
              }
            }
          });
        }
      }, 100);

      // Trigger plugin reload
      $.ajax({
        url: '/wp-content/themes/sekure/classes/sm-plugin-reload.php',
        type: 'post',
        success: function (response) {
          console.log(response);
        },
        error: function (response) {
          console.log(response);
        },
      });
      */
    });
  }
}, 100);

var checkAcceptAll = setInterval(function () {
  if ($('#ensModalAcceptAll').length) {
    console.log('ensModalAcceptAll exists!');
    clearInterval(checkAcceptAll);

    $('#ensModalAcceptAll').on('click', function () {
      console.log('all settings saved');

      loadScripts();

      if($('#hubspot_load_forms_cookie').length && $('#hubspot_load_forms_cookie').attr('src') == 'https://js-na3.hsforms.net/forms/embed/v2.js') {
        console.log('hubspot load forms cookie script is ready');

        var hbsptDefined = setInterval(function(){
          if(typeof hbspt !== 'undefined') {
            clearInterval(hbsptDefined);
            $('script').each(function (index) {
              if ($(this).html().indexOf('hbspt.forms.create') != -1) {
                if($(this).siblings('.hbspt-form').length == 0) {
                  var scriptForm = document.createElement('script');
                  scriptForm.innerHTML = $(this).html();
                  scriptForm.id = 'reloaded_script_' + index;
                  try {
                    $(this).parent().append(scriptForm);
                    if ($('head').find('.hbspt-form').length) {
                      $('head').find('.hbspt-form').appendTo($(this).parent());
                      console.log('form inserted');
                    }
                  } catch (error) {
                    console.log("ERROR MESSAGE: ", error);
                  }
                }
              }
            });
          } else {
            console.log('hubspot script loaded but hbspt function not available yet');
          }
        }, 500);
      }
    });
  }
}, 100);

var ensAcceptAll = setInterval(function () {
  if ($('#ensAcceptAll').length) {
    console.log('ensAcceptAll exists!');
    clearInterval(ensAcceptAll);

    $('#ensAcceptAll').on('click', function () {
      console.log('all settings saved');

      loadScripts();

      if($('#hubspot_load_forms_cookie').length && $('#hubspot_load_forms_cookie').attr('src') == 'https://js-na3.hsforms.net/forms/embed/v2.js') {
        console.log('hubspot load forms cookie script is ready');

        var hbsptDefined = setInterval(function(){
          if(typeof hbspt !== 'undefined') {
            clearInterval(hbsptDefined);
            $('script').each(function (index) {
              if ($(this).html().indexOf('hbspt.forms.create') != -1) {
                if($(this).siblings('.hbspt-form').length == 0) {
                  var scriptForm = document.createElement('script');
                  scriptForm.innerHTML = $(this).html();
                  scriptForm.id = 'reloaded_script_' + index;
                  try {
                    $(this).parent().append(scriptForm);
                    if ($('head').find('.hbspt-form').length) {
                      $('head').find('.hbspt-form').appendTo($(this).parent());
                      console.log('form inserted');
                    }
                  } catch (error) {
                    console.log("ERROR MESSAGE: ", error);
                  }
                }
              }
            });
          } else {
            console.log('hubspot script loaded but hbspt function not available yet');
          }
        }, 500);
      }
    });
  }
}, 100);

